"use client";
import React, { useState } from "react";
import { Button, Form, FormProps, Input } from "antd";
import { FiMapPin } from "react-icons/fi";
import { FieldNamesType } from "antd/es/cascader";
import Loader from "../loader";
import { getPanelUrl } from "@/app/constants/general";

type FieldType = {
  address: string;
};

type FormGetAddressProps = {
  formName: string;
  formBodyClass?: string;
};
const FormGetAddress = ({ formName, formBodyClass }: FormGetAddressProps) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish: FormProps<FieldNamesType>["onFinish"] = () => {
    form.resetFields();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    form.resetFields();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (event.key === "Enter") {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      form.resetFields();
    }
  };
  return (
    <Form
      name={formName}
      form={form}
      layout="vertical"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      autoComplete="off"
      className={`${formBodyClass} w-full`}
      onKeyDown={(event) => handleKeyDown(event)}
    >
      <div className="flex relative w-full items-end">
        <Form.Item<FieldType>
          label={
            <span
              className={`${
                formName === "startForm" ? "" : "text-white"
              } font-normal text-tiny`}
            >
              برای شروع آدرس خود را وارد کنید.
            </span>
          }
          name="address"
          className="w-full"
        >
          <Input
            className="flex flex-1 h-10 lg:h-14 xl:h-15"
            style={{ borderRadius: "0 0.5rem 0.5rem 0" }}
            placeholder="آدرس"
            prefix={<FiMapPin color="var(--color-primary)" size={18} />}
          />
        </Form.Item>
        <Form.Item label={null}>
          <Button
            type="primary"
            htmlType="submit"
            className="w-12 lg:w-18 !rounded-s-none !h-10 lg:!h-14 xl:!h-15 text-xs lg:!text-sm flex items-center justify-center !font-semibold"
            disabled={isLoading}
            onClick={() =>
              window.open(getPanelUrl(), "_blank", "noopener,noreferrer")
            }
          >
            {isLoading ? <Loader /> : "شروع"}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default FormGetAddress;
